export default {
  state: {
    headerCache: {}
  },
  getters: {
    getHeaders: state => id => {
      return state.headerCache[id]
    }
  },
  mutations: {
    setCacheData(state, data) {
      state.headerCache[data.key] = data.value
    }
  },
  actions: {
    setHeaders({ commit }, data) {
      commit('setCacheData', data)
    }
  }
}

